import { CargoOperationTypeEnum } from '../../enums/cargoOperationTypeEnum';
import { EventDate } from './EventDate';
import { EventType } from './EventType';
import { EventTypeInputReg } from './EventTypeInputReg';
import { RotationTreeEnum } from '../../enums/rotationTreeEnum';
import { DropdownTypeEnum } from '../../enums/dropdownTypeEnum';
import { ReportLocationEnum } from '../../enums/reportLocationEnum';

export class TankersEvent {
    constructor(
        eventId: string | null, // GUID
        eventTypeGroupSequenceIdentity: string | null,
        eventTypeGroupSequenceDependencyIdentity: string | null,
        eventTypeId: number | null,
        dependencyDisplayName: string | null,
        shipId: number,
        portCallId: number | null,
        berthCallId: number | null,
        berthId: number | null,
        berthSequenceNumber: number | null,
        cargoOperationId: number | null,
        delayEventFromId: string | null,
        delayEventToId: string | null,
        concurrentSequenceNumber: number | null,
        eventDate: EventDate,
        created: Date | null,
        lastUpdated: Date | null,
        updatedBy: string | null,
        deleted: boolean | null,
        eventTypeInputRegList: EventTypeInputReg[] | null,
        eventLevel: RotationTreeEnum | null,
        portId: number | null,
        voyageNumber: string | null,
        voyageNumber1: number | null,
        voyageNumber2: number | null,
        cargoNumber: string | null,
        cargoId: number | null,
        imosCargoId: number | null,
        operationType: CargoOperationTypeEnum | null,
        weight: number | null,
        tradeName: string | null,
        eventTypeDataVersion: string | null,
        eventTypeContextId: ReportLocationEnum | null,
        frontendVersion: number,
        portName: string | null,
        portClusterInitialPortId: number | null,
        portClusterInitialPortName: string | null,
        berthName: string | null,
        delayExceeded: boolean
    ) {
        this.eventId = eventId;
        this.eventTypeGroupSequenceIdentity = eventTypeGroupSequenceIdentity;
        this.eventTypeGroupSequenceDependencyIdentity = eventTypeGroupSequenceDependencyIdentity;
        this.eventTypeId = eventTypeId;
        this.dependencyDisplayName = dependencyDisplayName;
        this.eventType = null;
        this.shipId = shipId;
        this.portCallId = portCallId;
        this.berthCallId = berthCallId;
        this.berthId = berthId;
        this.berthSequenceNumber = berthSequenceNumber;
        this.cargoOperationId = cargoOperationId;
        this.delayEventFromId = delayEventFromId;
        this.delayEventToId = delayEventToId;
        this.concurrentSequenceNumber = concurrentSequenceNumber;
        this.eventDate = eventDate;
        this.created = created;
        this.lastUpdated = lastUpdated;
        this.updatedBy = updatedBy;
        this.deleted = deleted;
        this.eventTypeInputRegList = eventTypeInputRegList;
        this.eventLevel = eventLevel;
        this.portId = portId;
        this.voyageNumber = voyageNumber;
        this.voyageNumber1 = voyageNumber1;
        this.voyageNumber2 = voyageNumber2;
        this.cargoNumber = cargoNumber;
        this.cargoId = cargoId;
        this.imosCargoId = imosCargoId;
        this.operationType = operationType;
        this.weight = weight;
        this.tradeName = tradeName;
        this.eventTypeDataVersion = eventTypeDataVersion;
        this.eventTypeContextId = eventTypeContextId;
        this.frontendVersion = frontendVersion;
        this.deletedBerthCallAdded = false;
        this.evListdisplayStr = null;
        this.evListInputStr = null;
        this.isEditable = true;
        this.isDeletable = true;
        this.portName = portName;
        this.portClusterInitialPortId = portClusterInitialPortId;
        this.portClusterInitialPortName = portClusterInitialPortName;
        this.berthName = berthName;
        this.delayExceeded = delayExceeded;
    }
    eventId: string | null;
    eventTypeGroupSequenceIdentity: string | null;
    eventTypeGroupSequenceDependencyIdentity: string | null;
    eventTypeId: number | null;
    dependencyDisplayName: string | null;
    eventType: EventType | null;
    shipId: number;
    portCallId: number | null;
    berthCallId: number | null;
    berthId: number | null;
    berthSequenceNumber: number | null;
    cargoOperationId: number | null;
    delayEventFromId: string | null;
    delayEventToId: string | null;
    concurrentSequenceNumber: number | null;
    eventDate: EventDate;
    created: Date | null;
    lastUpdated: Date | null;
    updatedBy: string | null;
    deleted: boolean | null;
    eventTypeInputRegList: EventTypeInputReg[] | null;
    eventLevel: RotationTreeEnum | null;
    portId: number | null;
    voyageNumber: string | null;
    voyageNumber1: number | null;
    voyageNumber2: number | null;
    cargoNumber: string | null;
    cargoId: number | null;
    imosCargoId: number | null;
    operationType: CargoOperationTypeEnum | null;
    weight: number | null;
    tradeName: string | null;
    eventTypeDataVersion: string | null;
    eventTypeContextId: ReportLocationEnum | null;
    frontendVersion: number;
    deletedBerthCallAdded: boolean;
    evListdisplayStr: string | null;
    evListInputStr: string | null;
    isEditable: boolean;
    isDeletable: boolean;
    portName: string | null;
    portClusterInitialPortId: number | null;
    portClusterInitialPortName: string | null;
    berthName: string | null;
    delayExceeded: boolean;
    portClusterCallId?: number;
    portClusterId?: number;

    public isActual(): boolean {
        return !!this.eventDate.actualDateTimeUtc;
    }

    public isPlanned(): boolean {
        return !!(!this.eventDate.actualDateTimeUtc && this.eventDate.plannedDateTimeUtc);
    }

    public getEventLevel(): RotationTreeEnum {
        if (this.eventTypeContextId === ReportLocationEnum.Sea) {
            return RotationTreeEnum.Sea;
        }
        if (this.cargoOperationId) {
            return RotationTreeEnum.CargoOperation;
        } else if (this.berthCallId) {
            return RotationTreeEnum.BerthCall;
        } else {
            return RotationTreeEnum.PortCall;
        }
    }

    getCargoIds(): number[] {
        if (this.getEventLevel() === RotationTreeEnum.CargoOperation) {
            return this.cargoOperationId ? [this.cargoOperationId] : [];
        } else if (this.eventTypeInputRegList) {
            const eventTypeInputDropdownArray = this.eventTypeInputRegList.filter((drdownGr) => {
                return drdownGr.dropdownGroupReg;
            });

            const eventInputGroupRegListFilteredOnCargo = eventTypeInputDropdownArray.filter((evInpGr) => {
                if (evInpGr.dropdownGroupReg) {
                    switch (evInpGr.dropdownGroupReg.dropdownTypeId) {
                        case DropdownTypeEnum.CargoLoadingAndUnloadingOperations:
                        case DropdownTypeEnum.CargoLoadingOperations:
                        case DropdownTypeEnum.CargoUnloadingOperations:
                            return true;
                        default:
                            return false;
                    }
                }
                return false;
            });

            const dropdownGroupRegList = eventInputGroupRegListFilteredOnCargo.flatMap((eigr) => eigr.dropdownGroupReg);
            const allDropdownItemInput = dropdownGroupRegList.flatMap((ddgr) => ddgr && ddgr.dropdownItemRegList);

            let cargoIds = allDropdownItemInput.map((eti) => eti && eti.dropdownItemId);
            cargoIds = cargoIds.filter(function (v, i) {
                return cargoIds.indexOf(v) == i;
            });
            const ids: number[] = [];
            cargoIds.map((o) => {
                if (o) {
                    ids.push(o);
                }
            });
            return ids;
        }
        return [];
    }
}
